var i=5242880,o="image/jpeg",p="image/png",a="application/pdf",e="image/gif",m="application/msword",n="application/vnd.openxmlformats-officedocument.wordprocessingml.document";export{m as DOC,n as DOCX,e as GIF,o as JPG,i as MAX_FILE_SIZE,a as PDF,p as PNG};
//# sourceMappingURL=file.js.map
